import { render } from "./PastorRegistrationView.vue?vue&type=template&id=22eb1123&scoped=true"
import script from "./PastorRegistrationView.vue?vue&type=script&lang=js"
export * from "./PastorRegistrationView.vue?vue&type=script&lang=js"

import "./PastorRegistrationView.vue?vue&type=style&index=0&id=22eb1123&scoped=true&lang=css"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eb1123"]])

export default __exports__